// extracted by mini-css-extract-plugin
export var bodySections = "_9r-8";
export var gray = "_9r-7";
export var green = "_9r-4";
export var iconContainer = "_9r-9";
export var iconWidgetContainer = "_9r-1";
export var phoneIcon = "_9r-2";
export var red = "_9r-5";
export var statusDot = "_9r-3";
export var widgetContainer = "_9r-0";
export var yellow = "_9r-6";